const NOTICES_KEY = "dh_j_system_notices";
const ACKS_KEY = "dh_j_notice_acks";

const SEED = [
  {
    id: "sys-legal-launch-2026-09",
    kind: "security",
    title: "Legal update — EULA, backup, restore, and supported systems",
    summary:
      "Launch legal pages now cover Windows/Mac backup duty, restore point limits, suspension rules, and data retention. Review and acknowledge.",
    body: "Read the EULA at /eula and Disclaimer at /disclaimer. Export your checklist from /backup on a Windows PC or Apple Mac before device changes or account closure. Restore points are device-local rollbacks — not a cloud backup.",
    released_at: "2026-09-23T09:00:00.000Z",
  },
  {
    id: "sys-security-2026-08",
    kind: "security",
    title: "Security update — session and archive integrity",
    summary:
      "DreamHome Journey applied a quiet security refresh for sign-in, message attachments, and archive snapshots. No action is required beyond acknowledging this notice.",
    body: "This update tightens local session handling and keeps export/archive records aligned with the retention log. It does not change how buyer and seller checklists are stored.",
    released_at: "2026-08-12T09:00:00.000Z",
  },
  {
    id: "sys-annual-2026",
    kind: "annual",
    title: "Annual system upgrade — woodland desks",
    summary:
      "The yearly platform upgrade is in place: calmer desks, clearer notices, and room for broker-requested tools after office interviews.",
    body: "Annual upgrades land once a year so offices are not asked to relearn the product mid-season. Acknowledge when you have read the summary.",
    released_at: "2026-08-01T09:00:00.000Z",
  },
  {
    id: "sys-feature-messaging",
    kind: "feature",
    title: "Major feature — Messages, archive, and office inquiries",
    summary:
      "Agent–client threads, broker supervision, close/abandon archive, and broker/agent inquiries now live in Messages.",
    body: "System Notices (this page) are product updates. Unread notes in Messages are conversation alerts. They are never mixed.",
    released_at: "2026-07-20T09:00:00.000Z",
  },
];

function readJson(key, fallback) {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || "null");
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function listSystemNotices() {
  const stored = readJson(NOTICES_KEY, []);
  const byId = new Map(SEED.map((item) => [item.id, item]));
  stored.forEach((item) => {
    if (item?.id) byId.set(item.id, item);
  });
  return [...byId.values()].sort((a, b) => String(b.released_at).localeCompare(String(a.released_at)));
}

export function publishSystemNotice(notice) {
  const list = listSystemNotices();
  const next = {
    id: notice.id || crypto.randomUUID(),
    kind: notice.kind || "feature",
    title: notice.title,
    summary: notice.summary || "",
    body: notice.body || "",
    released_at: notice.released_at || new Date().toISOString(),
  };
  writeJson(NOTICES_KEY, [next, ...list.filter((item) => item.id !== next.id)]);
  return next;
}

export function listNoticeAcks(userId) {
  if (!userId) return {};
  const all = readJson(ACKS_KEY, {});
  return all[userId] || {};
}

export function acknowledgeNotice(userId, noticeId) {
  if (!userId || !noticeId) return listNoticeAcks(userId);
  const all = readJson(ACKS_KEY, {});
  const mine = { ...(all[userId] || {}) };
  mine[noticeId] = { acknowledged_at: new Date().toISOString() };
  all[userId] = mine;
  writeJson(ACKS_KEY, all);
  return mine;
}

export function unacknowledgedCount(userId) {
  const acks = listNoticeAcks(userId);
  return listSystemNotices().filter((item) => !acks[item.id]).length;
}

export function kindLabel(kind) {
  if (kind === "security") return "Security update";
  if (kind === "annual") return "Annual upgrade";
  return "Major feature";
}
